<h1 mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
  Der findes allerede et {{ serviceordre.opgaveDisplayText | lowercase }} inden for 48 timer
</h1>
<button class="btn-close btn-icon" mat-dialog-close title="Luk dialog">
  <mat-icon class="material-icons">close</mat-icon>
</button>

<div mat-dialog-content>
  <p>
    {{ serviceordre.opgaveDisplayText }} oprettet {{ serviceordre.createdOn | date: 'dd.MM.yyyy' }} med deadline
    {{ serviceordre.deadline | date: 'dd.MM.yyyy' }}
  </p>
  @if (serviceordre.kombineredeNoter) {
    <p>Note: {{ serviceordre.kombineredeNoter }}</p>
  }
  <p>Vil du fortsætte?</p>
</div>
<div mat-dialog-actions class="row-reverse">
  <button mat-raised-button color="primary" mat-dialog-close>Fortryd</button>
  <button mat-raised-button [mat-dialog-close]="data">Opret {{ data.opgavetype | lowercase }}</button>
</div>
